import { NavLink, Outlet } from 'react-router-dom';
import { Package, History, Layers, BookUser, Settings, Search, Bell } from 'lucide-react';

const navCls = ({ isActive }: { isActive: boolean }) =>
  isActive ? 'nav-item active' : 'nav-item';

function Layout() {
  return (
    <div className="app">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>

      {/* Top bar */}
      <header className="topbar">
        <div className="brand">
          <img src="/favicon.svg" alt="" className="brand-logo" />
          <span className="brand-word">FIFTY 410</span>
        </div>
        <div className="topbar-sep" />
        <span className="status-badge success">
          <span className="dot" />
          Production
        </span>

        <div className="top-search">
          <div>
            <Search size={15} aria-hidden="true" />
            <span style={{ flex: 1 }}>Search orders, recipients, tracking…</span>
            <kbd>⌘K</kbd>
          </div>
        </div>

        <button type="button" className="worker-chip">
          <span
            style={{
              width: 7,
              height: 7,
              borderRadius: '50%',
              background: 'var(--success-dot)',
            }}
          />
          Worker · Connected
        </button>
        <button type="button" className="icon-btn" aria-label="Notifications">
          <Bell size={17} />
        </button>
        <div className="avatar" aria-hidden="true">
          OS
        </div>
      </header>

      <div className="app-body">
        {/* Sidebar navigation */}
        <nav className="sidebar" aria-label="Main navigation">
          <div className="nav-label">Shipping</div>
          <NavLink to="/" end className={navCls}>
            <Package size={17} />
            <span>Create shipment</span>
          </NavLink>
          <NavLink to="/orders" className={navCls}>
            <History size={17} />
            <span>Orders</span>
          </NavLink>
          <NavLink to="/bulk-ship" className={navCls}>
            <Layers size={17} />
            <span>Bulk ship</span>
          </NavLink>

          <div className="nav-label">Manage</div>
          <NavLink to="/addresses" className={navCls}>
            <BookUser size={17} />
            <span>Address book</span>
          </NavLink>
          <NavLink to="/settings" className={navCls}>
            <Settings size={17} />
            <span>Settings</span>
          </NavLink>

          <div className="sidebar-foot">
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 7,
                fontSize: '.74rem',
                color: 'var(--ink-2)',
              }}
            >
              <span
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: '50%',
                  background: 'var(--success-dot)',
                }}
              />
              FedEx account · live
            </div>
          </div>
        </nav>

        {/* Routed pages render here */}
        <main id="main-content" className="app-main">
          <div className="page">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}

export default Layout;
